let language = {
    
    // 
    STANDARD_ORDER_TOTAL: "Total:",

    // 
    STANDARD_ORDER_SHIPPING_SIGN: "SHIPPING",
    
    // 
    STANDARD_ORDER_BACK_BTN: "Back",
    STANDARD_ORDER_CANCEL_ORDER_BTN: "Cancel order",
    STANDARD_ORDER_CONTINUE_PAY_BTN: "Continue to Pay",
};

export { language }